import React from 'react';
import {injectIntl} from 'react-intl';
import {Link} from 'react-router-dom';

let breadcrumbListItems = [];

const Breadcrumbs = ({intl, jobSearchUrl}) => {
  breadcrumbListItems = [];
  const breadcrumbList = [
    <li className="breadcrumb__item" key='home'>
      <a className="breadcrumb__link" href="/">{intl.formatMessage({id: 'Breadcrumbs.Home'})}</a>
    </li>,
    <li className="breadcrumb__item" key='jobs'>
      <Link className="breadcrumb__link" to={jobSearchUrl}>{intl.formatMessage({id: 'Breadcrumbs.FindEmployees'})}</Link>
    </li>,
  ];
  addItem('/', intl.formatMessage({id: 'Breadcrumbs.Home'}));
  addItem(jobSearchUrl, intl.formatMessage({id: 'Breadcrumbs.FindEmployees'}));
  // Remove the link from the last element.
  const lastElement = breadcrumbList[breadcrumbList.length-1];
  breadcrumbList[breadcrumbList.length-1] = React.cloneElement(lastElement, {children: lastElement.props.children.props.children});
  // Get the last but one breadcrumb element and add class to it.
  const lastButOneElement = breadcrumbList[breadcrumbList.length-2].props.children;
  const breadcrumbsMobile = React.cloneElement(lastButOneElement, {className: 'breadcrumb__link hidden--from-l'});

  return (
    <div className="navigation__bottom">
      <nav className="breadcrumb" aria-label="breadcrumb">
        {breadcrumbsMobile}
        <ul className="breadcrumb__list hidden--until-l">
          {breadcrumbList}
        </ul>
      </nav>
      {getScript()}
    </div>
  );
};

/**
 * Add item to breadcrumbListItems.
 * @param {string} url of the breadcrumb item.
 * @param {string} name name of the breadcrumb item.
 */
function addItem(url, name) {
  breadcrumbListItems.push({url: url, name: name});
}

/**
 * Get the breadcrumbList script.
 * @return {*}
 */
function getScript() {
  const breadcrumbListScript = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [],
  };
  breadcrumbListItems.forEach((item, index) => {
    breadcrumbListScript.itemListElement.push({
      '@type': 'ListItem',
      'position': index + 1,
      'item': {
        '@id': `${process.env.REACT_APP_BASE_URL}${item.url}`, 'name': item.name,
      },
    });
  });
  return (
    <script type="application/ld+json">
      {JSON.stringify(breadcrumbListScript)}
    </script>);
}

export default injectIntl(Breadcrumbs);
